module.exports = __webpack_public_path__ + "static/media/cooperation.18531f1d.jpg";